import React from "react";
import {
    FormControlLabel,
    Tooltip,
    Checkbox
} from "@mui/material";

const VerifyCheckBox = ({ title, handleChange, checked }) => {
    return (
        <FormControlLabel
            control={
                <Tooltip title={title} arrow>
                    <Checkbox
                        checked={checked}
                        onChange={handleChange}
                        size="small"
                        sx={{
                            marginTop:
                                [
                                    '-0.3rem',
                                    '-0.3rem',
                                    '-0.3rem',
                                    '-0.3rem',
                                    '-0.2rem', '-0.2rem',
                                ],
                            color: checked ? 'green' : 'primary',
                            '&.Mui-checked': {
                                color: 'green',
                            },
                        }}
                    />
                </Tooltip>
            }
            label={""}
            sx={{ ml: 0.05 }}
        />
    )

}

export default VerifyCheckBox;